import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";
import { StudentInfoModel, UserBasicInfoModel } from "@modules/user-admin/user-types.ts";

const acknowledgeAdvisoryNote = (): Promise<ApiResponse<string>> => {
  return httpClient.post(`/apis/user/advisory/acknowledge`);
};

const resendActivationEmail = (userUuid: string): Promise<ApiResponse> => {
  return httpClient.get(`/apis/user/resend/welcomeemail`, { params: { uuid: userUuid } });
};

// TODO: [API] rename api url from users -> user
const fetchTeachers = (requestData) => {
  return httpClient.post(`/apis/users/search`, requestData, {});
};

const fetchUserInfo = (userId: number): Promise<ApiResponse<StudentInfoModel>> => {
  return httpClient.get(`/apis/user/getinfo`, {
    params: {
      userId: userId,
    },
  });
};

const fetchUserBasicInfo = (userIds: number[]): Promise<ApiResponse<UserBasicInfoModel[]>> => {
  return httpClient.get(`/apis/user/get/basicinfo`, {
    params: {
      userIds: userIds,
    },
  });
};

export default {
  acknowledgeAdvisoryNote,
  resendActivationEmail,
  fetchUserInfo,
  fetchUserBasicInfo,
  fetchTeachers,
};
